import { render, staticRenderFns } from "./DemonstrativeAmountsPaidForm.vue?vue&type=template&id=67755502&scoped=true"
import script from "./DemonstrativeAmountsPaidForm.vue?vue&type=script&lang=js"
export * from "./DemonstrativeAmountsPaidForm.vue?vue&type=script&lang=js"
import style0 from "./DemonstrativeAmountsPaidForm.vue?vue&type=style&index=0&id=67755502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67755502",
  null
  
)

export default component.exports